import React, { ReactElement } from 'react'
import { Icon, Modal } from '@myeh/design-system'

import style from './SimpleModal.module.scss'

export function SimpleModal({
  open,
  onClose,
  titleIcon,
  title,
  body,
  footer,
  hideOnClickOutside,
  showCloseIcon,
  testId
}: {
  open: boolean
  onClose: () => void
  titleIcon?: 'error' | 'success'
  title: string
  body?: ReactElement
  footer: ReactElement
  hideOnClickOutside?: boolean
  showCloseIcon?: boolean
  testId?: string
}): ReactElement {
  return (
    <Modal
      open={open}
      onClose={onClose}
      hideOnClickOutside={hideOnClickOutside}
      showCloseIcon={showCloseIcon}
      data-testid={testId}
      /*
       * The fallbackFocus='body' param avoid to have the unit test error :
       * "Your focus-trap must have at * least one container with at least one tabbable node in it at all * times"
       */
      fallbackFocus='body'
    >
      <div className='flex mb3'>
        {titleIcon === 'success' && <Icon name='check-circle' className={`${style.iconSuccess} mr2`} size='small' />}
        {titleIcon === 'error' && (
          <Icon name='exclamation-triangle' className={`${style.iconError} mr2`} size='small' />
        )}
        <h2 className={`mv0 ${style.title}`}>{title}</h2>
      </div>
      {body && <div>{body}</div>}
      <div className='flex justify-end mt4'>{footer}</div>
    </Modal>
  )
}
